import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { SanitizedFeedSectionArticle } from "@typings/Cue";
import { startCase, toLower } from "lodash-es";

/**
 * Returns the card props for the BTLuxe component.
 * @param articles - The articles to be displayed in the component.
 * @param ref - The reference to be used for the link.
 * @returns {ComponentProps<typeof Card>[]} - The card props for the BTLuxe component.
 */
export const getBTLuxeCardProps = (
  articles: SanitizedFeedSectionArticle[]
): ComponentProps<typeof Card>[] => {
  const cardProps = articles.map(
    ({ id, title, urlPath, media, blurb, kicker, updated }) => {
      const mainMedia = media[0];
      const imgSrc = mainMedia?.landscape?.url;
      const imgWidth = mainMedia?.landscape?.width;
      const imgHeight = mainMedia?.landscape?.height;

      const props: ComponentProps<typeof Card> = {
        id,
        link: urlPath,
        title,
        thumbnail:
          imgSrc && imgWidth && imgHeight
            ? {
                src: imgSrc,
                alt: mainMedia.alt || mainMedia.caption || "",
                width: imgWidth,
                height: imgHeight,
              }
            : undefined,
        defaultImage: { directoryName: "lifestyle" },
        blurb: blurb,
        kicker: startCase(toLower(kicker?.fields?.[0]?.value)),
        updatedTime: updated,
      };

      return props;
    }
  );

  return JSON.parse(JSON.stringify(cardProps));
};
